import { VStack, Text, Heading, Tag, HStack, useToken } from '@chakra-ui/react';

import formatPriceNumber from '~/utils/formatPriceNumber';

type ItemInfoSectionProps = {
  name: string;
  tags: Array<string>;
  description: string;
  price: number;
  inventory?: string;
};

export default function ItemInfoSection({
  name,
  tags,
  description,
  price,
  inventory = '',
}: ItemInfoSectionProps) {
  const [primaryLight] = useToken('colors', ['primaryLight']);

  return (
    <VStack align="flex-start" spacing={2}>
      <Heading size="sm">{name}</Heading>
      <HStack>
        {tags.map((tag) => (
          <Tag
            key={tag}
            px={3}
            size="md"
            variant="outline"
            color="secondary"
            fontWeight="normal"
            boxShadow={`inset 0 0 0 1px ${primaryLight}`}
          >
            {tag}
          </Tag>
        ))}
      </HStack>
      <Text fontSize="xs" color="gray.500">
        {description}
      </Text>
      <Heading size="sm">{formatPriceNumber(price)}</Heading>

      {/** not implement in this version */}
      <Text fontSize="xs" color="gray.500">
        剩餘 {inventory}
      </Text>
    </VStack>
  );
}
